// Cálculo de fechas de entrega, compartido por los bloques de envío.
// ponytail: se calcula en el navegador, no en Liquid — Shopify cachea el HTML y una
// fecha renderizada por servidor se queda congelada de un día para otro.

function lanzoClave(date) {
  // clave local YYYY-MM-DD: toISOString convierte a UTC y en Colombia (UTC-5)
  // devolvería el día anterior
  const m = `${date.getMonth() + 1}`.padStart(2, '0');
  const d = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${m}-${d}`;
}

// Domingo de Pascua (Meeus/Jones/Butcher)
function lanzoPascua(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mes = Math.floor((h + l - 7 * m + 114) / 31);
  const dia = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, mes - 1, dia);
}

// Ley Emiliani: el festivo se traslada al lunes siguiente si no cae en lunes
function lanzoLunesSiguiente(date) {
  const d = new Date(date.getTime());
  const dow = d.getDay();
  if (dow !== 1) d.setDate(d.getDate() + ((8 - dow) % 7));
  return d;
}

function lanzoFestivosColombia(year) {
  const pascua = lanzoPascua(year);
  const desdePascua = (offset) => {
    const d = new Date(pascua.getTime());
    d.setDate(d.getDate() + offset);
    return d;
  };

  const fijos = [
    [0, 1], // Año Nuevo
    [4, 1], // Día del Trabajo
    [6, 20], // Independencia
    [7, 7], // Batalla de Boyacá
    [11, 8], // Inmaculada Concepción
    [11, 25], // Navidad
  ].map(([m, d]) => new Date(year, m, d));

  const trasladables = [
    [0, 6], // Reyes Magos
    [2, 19], // San José
    [5, 29], // San Pedro y San Pablo
    [7, 15], // Asunción
    [9, 12], // Día de la Raza
    [10, 1], // Todos los Santos
    [10, 11], // Independencia de Cartagena
  ].map(([m, d]) => lanzoLunesSiguiente(new Date(year, m, d)));

  const pascuales = [
    desdePascua(-3), // Jueves Santo
    desdePascua(-2), // Viernes Santo
    desdePascua(43), // Ascensión (ya trasladada a lunes)
    desdePascua(64), // Corpus Christi
    desdePascua(71), // Sagrado Corazón
  ];

  return new Set([...fijos, ...trasladables, ...pascuales].map(lanzoClave));
}

// caché por año: la lista no cambia dentro de una misma carga
const lanzoFestivosCache = {};
function lanzoFestivos(year) {
  if (!lanzoFestivosCache[year]) lanzoFestivosCache[year] = lanzoFestivosColombia(year);
  return lanzoFestivosCache[year];
}

function lanzoEsHabil(date, skipWeekends, skipHolidays) {
  const dow = date.getDay();
  if (skipWeekends && (dow === 0 || dow === 6)) return false;
  if (skipHolidays && lanzoFestivos(date.getFullYear()).has(lanzoClave(date))) return false;
  return true;
}

function lanzoAddDays(date, days, skipWeekends, skipHolidays) {
  const d = new Date(date.getTime());
  let left = Math.max(0, days);
  // tope de seguridad: sin él, una configuración absurda colgaría la pestaña
  let guard = 0;
  while (left > 0 && guard < 3650) {
    d.setDate(d.getDate() + 1);
    guard += 1;
    if (lanzoEsHabil(d, skipWeekends, skipHolidays)) left -= 1;
  }
  return d;
}

function lanzoMonth(date, locale) {
  return date.toLocaleDateString(locale, { month: 'short' }).replace('.', '');
}

function lanzoFullDate(date, locale) {
  return date
    .toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' })
    .replace(/[,.]/g, '');
}

function lanzoRange(from, to, locale) {
  const mesFin = lanzoMonth(to, locale);
  if (from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) {
    return `${from.getDate()} – ${to.getDate()} ${mesFin}`;
  }
  return `${from.getDate()} ${lanzoMonth(from, locale)} – ${to.getDate()} ${mesFin}`;
}
